import React from "react";
import styles from "./logo.module.scss";
import { getUrlRedirectMarketplaceAuth } from "commons/utils/Utils";
import {Logo as LogoStorybook} from "superbid-ui"

interface LogoProps {
    children?: any;
    url?: string;
}

export const Logo: React.FC<LogoProps> = ({ url }) => {
    return (
        <LogoStorybook 
            url={url}
            onClick={() =>
                window.location.href = getUrlRedirectMarketplaceAuth()
            }/>
    )
}
